module.exports = __webpack_public_path__ + "img/map_4.e69f49bb.png";